module.exports = __webpack_public_path__ + "static/LangmanConstruction.983dc282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/LangmanConstruction.jpg
// module id = 480
// module chunks = 35783957827783